import $ from "jquery";
import { bootstrap, appclient } from "../config/bootstrap";
import { userDetailStore, translationStore } from "../config/store";
import CleverTapSdk from "./CleverTapSdk";

export const getResponse = (url, data, param, referer, noloader) => {
  if (typeof param !== "undefined") {
    var datas = {};
    var accesstoken = localStorage.getItem("accessToken");

    var resp = null;
    //        data['accessToken'] = '';
    datas = data;
    if (typeof accesstoken != "undefined") {
      datas["accessToken"] = accesstoken;
    }
    var request = $.ajax({
      async: true,
      url: bootstrap.API_URL + url,
      data: datas,
      method: "post",
      success: (data) => {
        //this function works in async becuase success method is used
        if (typeof function_x !== "undefined") {
          //function_x( data, param );
        }
        if (typeof referer !== "undefined") {
          var ob = {};
          if (data !== null) {
            ob[param] = data;
            referer.setState(ob);
          } else {
          }
        }
      },
      error: (data) => {
        //redirect to error page
        //     alert( "can't connect to server" );
        if (data.status === 400) {
          // commonErrorAlertStore.dispatch({"type":"SHOW_ALERT","display_type":"error","message":"Operation Not Allowed"});
        }
      },
      done: (data) => {
        // alert( data );
      },
    });
    //all value in resp.data for list.
    return request;
  }

  return resp;
};

export const getUrlParameter = (sParam) => {
  if(window.location.href.indexOf(sParam) != -1){
  var results = new RegExp("[/#?&]" + sParam + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
}
};

export const getUserDetail = (ref) => {
  var userId = getUrlParameter("userid");
  if (userId) {
    var params = {};
    params["userid"] = userId;
    params["token"] = appclient.nm_api_token;
    $.ajax({
      async: true,
      url: bootstrap.NM_API_URL + "getuserdata",
      data: params,
      method: "post",
      success: (data) => {
        if (data.data.length > 0) {
          var dataArr = data.data[0];
          var userDetail = {
            type: "GET_USERDETAIL",
            detail: dataArr,
            page: "homepage",
          };
          userDetailStore.dispatch(userDetail);
        }
      },
      error: (data) => {
        // alert( "error" );
      },
      done: (data) => {
        // alert( "done" );
      },
    });
  }
};

export const trim = (c) => {
  var ctx = c.getContext("2d"),
    copy = document.createElement("canvas").getContext("2d"),
    pixels = ctx.getImageData(0, 0, c.width, c.height),
    l = pixels.data.length,
    i,
    bound = {
      top: null,
      left: null,
      right: null,
      bottom: null,
    },
    x,
    y;

  for (i = 0; i < l; i += 4) {
    if (pixels.data[i + 3] !== 0) {
      x = (i / 4) % c.width;
      y = ~~(i / 4 / c.width);

      if (bound.top === null) {
        bound.top = y;
      }

      if (bound.left === null) {
        bound.left = x;
      } else if (x < bound.left) {
        bound.left = x;
      }

      if (bound.right === null) {
        bound.right = x;
      } else if (bound.right < x) {
        bound.right = x;
      }

      if (bound.bottom === null) {
        bound.bottom = y;
      } else if (bound.bottom < y) {
        bound.bottom = y;
      }
    }
  }

  var trimHeight = bound.bottom - bound.top;
  if (trimHeight == 0) {
    return false;
  }
  var trimWidth = bound.right - bound.left,
    trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

  copy.canvas.width = trimWidth;
  copy.canvas.height = trimHeight;
  copy.putImageData(trimmed, 0, 0);

  // open new window with trimmed image:
  return copy.canvas;
};

export const postDataBlob = (params, action, noloader) => {
  var platform = "web";
  var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
  if (isAndroid) {
    platform = "android";
  }
  var isiPhone = /iphone/i.test(navigator.userAgent.toLowerCase());
  if (isiPhone) {
    platform = "ios";
  }

  params["username"] = params["fullName"] ? params["fullName"] : "";
  params["platform"] = platform;
  params["token"] = appclient.api_token;
  params["action"] = action; //postdata
  params["userid"] = userDetailStore.getState().userDetail["user_id"];
  params["nmemail"] = userDetailStore.getState().userDetail["user_email"];
  params["statename"] = userDetailStore.getState().userDetail["state_name"];
  params["disttname"] = userDetailStore.getState().userDetail["district_name"];
  params["cityname"] = userDetailStore.getState().userDetail["city_name"];
  params["user_name"] = userDetailStore.getState().userDetail[
    "user_name_display"
  ];
  if (typeof noloader == "undefined") {
    $(".preloader_mantra").show();
  }
  var formData = new FormData();
  $.each(params, function (index, value) {
    formData.append(index, value);
  });

  var request = new XMLHttpRequest();

  request.open("POST", bootstrap.API_URL);
  request.send(formData);

  return request;
};

export const postData = (params, action, noloader) => {
  var platform = "web";
  var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
  if (isAndroid) {
    platform = "android";
  }
  var isiPhone = /iphone/i.test(navigator.userAgent.toLowerCase());
  if (isiPhone) {
    platform = "ios";
  }

  params["username"] = params["fullName"] ? params["fullName"] : "";
  params["platform"] = platform;
  params["token"] = appclient.api_token;
  params["action"] = action; //postdata
  params["userid"] = params && params.userid ? params.userid : userDetailStore.getState().userDetail && userDetailStore.getState().userDetail["user_id"];
  params["nmemail"] = userDetailStore.getState().userDetail && userDetailStore.getState().userDetail["user_email"];
  params["statename"] = userDetailStore.getState().userDetail && userDetailStore.getState().userDetail["state_name"];
  params["disttname"] = userDetailStore.getState().userDetail && userDetailStore.getState().userDetail["district_name"];
  params["cityname"] = userDetailStore.getState().userDetail && userDetailStore.getState().userDetail["city_name"];
  params["user_name"] = userDetailStore.getState().userDetail && userDetailStore.getState().userDetail[
    "user_name_display"
  ];
  params["ew_v"] = 2;

  if (typeof noloader == "undefined") {
    $(".preloader_mantra").show();
  }

  var request = $.ajax({
    async: true,
    url: bootstrap.API_URL,
    data: params,
    method: "post",
    success: function (response) {
      $(".preloader_mantra").hide();

      //            call clevertap
      if (response._resultflag == 1 && action == "savedata") {
        cleverTap(params);
      }
    },
  });

  return request;
};

/* Utility function to convert a canvas to a BLOB */
export const dataURLToBlob = function (dataURL) {
  var BASE64_MARKER = ";base64,";
  if (dataURL.indexOf(BASE64_MARKER) == -1) {
    var parts = dataURL.split(",");
    var contentType = parts[0].split(":")[1];
    var raw = parts[1];

    return new Blob([raw], { type: contentType });
  }

  var parts = dataURL.split(BASE64_MARKER);
  var contentType = parts[0].split(":")[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

export const cleverTap = function (jsonObj) {
  var cleverTapjson = {};
  if (jsonObj["nmemail"]) {
    cleverTapjson["identity"] = jsonObj["nmemail"];
  } else {
    cleverTapjson["identity"] = userDetailStore.getState().userDetail[
      "user_email"
    ];
  }

  cleverTapjson["module_subtype"] = jsonObj["module_subtype"];
  if (jsonObj["platform"]) {
    cleverTapjson["event_platform"] = jsonObj["platform"];
  } else {
    cleverTapjson["event_platform"] = jsonObj["platform"];
    cleverTapjson["event_platform"] = "web";
    var isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
    if (isAndroid) {
      cleverTapjson["event_platform"] = "android";
    }
    var isiPhone = /iphone/i.test(navigator.userAgent.toLowerCase());
    if (isiPhone) {
      cleverTapjson["event_platform"] = "ios";
    }
  }

  if (jsonObj["action"] == "savedata") cleverTapjson["event_action"] = "submit";
  else if (jsonObj["action"] == "sendmail")
    cleverTapjson["event_action"] = "email";
  else if (jsonObj["action"] == "download")
    cleverTapjson["event_action"] = "download";
  else cleverTapjson["event_action"] = jsonObj["event_action"];

  cleverTapjson["action"] = "ctevent";

  cleverTapjson["token"] = appclient.api_token;

  var request = $.ajax({
    async: true,
    url: bootstrap.API_URL,
    data: cleverTapjson,
    method: "post",
    success: function (response) { },
  });
  return request;
};

export const translation = (key, type) => {
  var jsondata = translationStore.getState().data;

  if (type == "image") {
    var upperkey = $.trim(key);
  } else {
    var upperkey = $.trim(key.toUpperCase());
  }
  if (getUrlParameter("lang") == "en") {
    return key;
  } else if (jsondata != null) {
    if (jsondata["" + upperkey + ""] != null) {
      return jsondata["" + upperkey + ""];
    } else {
      return key;
    }
  } else {
    return "";
  }
};

export const iOS = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

export const onShareClick = function (sharemode = "", cardId = "") {
  // var payload = {
  //   action: "share-analysis",
  //   token: localStorage.getItem("token"),
  //   data: {
  //     mode: sharemode,
  //     cardId: cardId + "",
  //     platform: localStorage.getItem("device")
  //       ? localStorage.getItem("device")
  //       : "pwa",
  //   },
  // };
  // var request = doRequest("netaji-jayanti-2021", payload, true);
  // request.addEventListener("load", function () {
  //   var response = JSON.parse(this.responseText);
  //   // if (response._resultflag == 1) {
  //   // }
  // });
};

export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split('‟').join('"') : "";
  text = text ? text.split('“').join('"') : "";
  text = text ? text.split('❝').join('"') : "";
  text = text ? text.split('❞').join('"') : "";
  text = text ? text.split('”').join('"') : "";
  text = text ? text.split('„').join('"') : "";
  return text;
};

export const onClickNavLinkMantra = (link, linkdetails) => {
  try {
    let ctdata = {};
    let linkname = linkdetails.name ? linkdetails.name : "";
    linkname = linkdetails.inner_name ? linkdetails.inner_name : linkname;

    ctdata["examwarriorsv2_action"] = "LinkClicked";
    ctdata["link"] = window.location.origin + link;
    ctdata["linkname"] = linkname;
    // CleverTapSdk.handleEventtracking(ctdata);
  } catch (er) { }
};

export const onImageFileUploaded = (data) => {
  if (data.module) {
    setDoneMantraTick(data.module)
  }
  try {
    let ctdata = {};
    ctdata["examwarriorsv2_action"] = "ImageUploaded";
    ctdata["filelink"] = data.image ? data.image : "";
    ctdata["module"] = data.module ? data.module : "";
    ctdata["postid"] = data.postid ? data.postid : "";
    // CleverTapSdk.handleEventtracking(ctdata);
  } catch (er) { }
};

export const postLikedDislikedCT = (data) => {
  try {
    let ctdata = {};
    ctdata["examwarriorsv2_action"] = "LikedDislikedPost";
    ctdata["postid"] = data.postid ? data.postid : "";
    ctdata["type"] = data.type ? data.type : "";
    // CleverTapSdk.handleEventtracking(ctdata);
  } catch (er) { }
};

export const onSocialShareCT = (data) => {
  if (data.module) {
    setDoneMantraTick(data.module)
  }
  try {
    let ctdata = {};
    ctdata["examwarriorsv2_action"] = "PostShared";
    ctdata["type"] = data.type ? data.type : "";
    ctdata["shareurl"] = data.shareurl ? data.shareurl : "";
    ctdata["text"] = data.text ? data.text : "";
    ctdata["image"] = data.image ? data.image : "";
    // CleverTapSdk.handleEventtracking(ctdata);
  } catch (er) { }
};

export const onDownloadImageCT = (data) => {
  if (data.module) {
    setDoneMantraTick(data.module)
  }
  try {
    let ctdata = {};
    ctdata["examwarriorsv2_action"] = "ImageDownloaded";
    ctdata["imagelink"] = data.imagelink ? data.imagelink : "";
    ctdata["module_name"] = data.inner_name ? data.inner_name : "";
    ctdata["postid"] = data.postid ? data.postid : "";
    // CleverTapSdk.handleEventtracking(ctdata);
  } catch (er) { }
};

export const setDoneMantraTick = (key) => {
  if (key) {
    let doneMantraArray = [];
    if (localStorage.getItem("doneMantraArray")) {
      doneMantraArray = JSON.parse(localStorage.getItem("doneMantraArray"));
    }
    if (!doneMantraArray.includes(key)) {
      doneMantraArray.push(key);
    }
    localStorage.setItem("doneMantraArray", JSON.stringify(doneMantraArray));
  } else {
    console.log("Key is not set for done tick!!!");
  }
};
